document.addEventListener("DOMContentLoaded", function () {
  const SELECTOR_ITEM = ".product_stitching_item_card";
  const SELECTOR_CARD = ".product-card-link";
  const SELECTOR_NEW_CARD = "main .product-card-link";
  const productCardCache = new Map();
  async function fetchProductCard(handle) {
    if (productCardCache.has(handle)) {
      return productCardCache.get(handle);
    }

    const url = `${handle}?view=product-card-template`;
    const response = await fetch(url);
    const html = await response.text();

    productCardCache.set(handle, html);
    return html;
  }
  document.body.addEventListener("click", async (event) => {
    const item = event.target.closest(SELECTOR_ITEM);
    if (!item) return;

    event.preventDefault();

    const productHandle = item.dataset.productHandle;
    const card = item.closest(SELECTOR_CARD);
    if (!card || !productHandle) return;

    try {
      const html = await fetchProductCard(productHandle);
      const temp = document.createElement("div");
      temp.innerHTML = html;
      const newCard = temp.querySelector(SELECTOR_NEW_CARD);

      if (newCard) card.replaceWith(newCard);
    } catch (err) {
      console.error("Error updating product card:", err);
    }
  });
});
